// extracted by mini-css-extract-plugin
export default {"pageSelectorContainer":"PageSelector_pageSelectorContainer__qJ7WE","pageSelector":"PageSelector_pageSelector__jM837"};